export function createArrayWithNumbers(length) {
  return Array.from({ length }, (_, k) => k);
}
